goog.provide('el8.ptdata.ptNextAppt');

goog.require('el8.practicedata.model.appt');
goog.require('el8.util.datecompare');

el8.ptdata.ptNextAppt = (function() {
    var that = el8.practicedata.model.appt({});
    return that;
})();
